import {Injectable} from "@angular/core";

import {AppointmentCreationService} from "../../../appointment-creation/service/appointment-creation.service";
import {AppointmentInformationDto} from "../model/appointment-information-dto";
import {UserActivationService} from "./user-activation.service";
import {throwError} from "rxjs";
import {formatDateTimeAsFakeUTC} from "../../../../lib/date-util";

@Injectable({ providedIn: 'root' })
export class AppointmentActivationService {
  constructor(
    private readonly appointmentCreationService: AppointmentCreationService,
    private readonly userActivationService: UserActivationService,
  ) {}

  sendActivationLink(phoneNumber: string, language: string) {
    const appointmentInfo = this.appointmentCreationService.selectedAppointmentInformation$.value;
    if (!appointmentInfo) {
     return;
    }

    const appointmentInformationDto: AppointmentInformationDto = {
      calendarId: appointmentInfo.openSlot.calendarId,
      motiveId: appointmentInfo.motiveIds[0],
      motiveName: appointmentInfo.motiveName!,
      categoryId: appointmentInfo.categoryId!,
      categoryName: appointmentInfo.categoryName!,
      medicalCenterId: appointmentInfo.medicalCenter!.id,
      startDateTime: formatDateTimeAsFakeUTC(appointmentInfo.openSlot.time),
      language: language,
    };

    return this.userActivationService.sendActivationLinkWithAppointmentInfo(phoneNumber, appointmentInformationDto)
      .subscribe({
        next: () => {
        },
        error: (err) => {
          return throwError(() => err);
        }
      });
  }
}
